export const TiposNotificacion = [
    {text: 'SOLICITUD DE EXONERACION', value: 'SOLICITUD DE EXONERACION'},
    {text: 'RECORDATORIO DE PAGO', value: 'RECORDATORIO DE PAGO'},
    {text: 'FECHA EVALUACION', value: 'FECHA DE EVALUACION'},
    {text: 'RECORDATORIO DE VENCIMIENTO DE DOCUMENTOS', value: 'VENCIMIENTO DE DOCUMENTO EN EXPEDIENTE'},
    {text: 'SOLICITUD DE EXAMEN DE RECUPERACION', value: 'SOLICITUD DE EXAMEN DE RECUPERACION'},
   
]